module.exports = __webpack_public_path__ + "img/phone.58cd6757.svg";